module.exports = "/images/stephan.jpg?b4c139c09b95fcb543c7e8cc9b41670a";